import React                                    from 'react';
import PropTypes                                from 'prop-types';
import {unmountComponentAtNode}                 from 'react-dom';
import Flux                                     from '../../flux/Flux';
import Translations                             from '../../utils/Translations';
import {VXPay}                                  from "../../utils/VXPay";
import VXButton                                 from "../../components/SimpleElements/VXButton/VXButton";
import {VXButtonLineConfig}                    from "../../components/SimpleElements/VXButton/VXButtonConfig";
import {COLOR_TYPE_MOOD_3, COLOR_TYPE_DISABLED} from "../../components/SimpleElements/VXButton/ButtonHelper";

class SubscribeToContests extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isSubscribed: false,
			requestError: false,
		};

		this.onResult    = this.onResult.bind(this);
		this.onClose     = this.onClose.bind(this);
		this.onSendClick = this.onSendClick.bind(this);
	}

	componentDidMount() {
		Flux.Guest.addAddRelationResultListener(this.onResult);

		if (Flux.Guest.isLoggedIn()) {
			Flux.Guest.hasGuestRelation(Flux.Constants.Relations.Predicates.HAS_SUBSCRIBED, Flux.Constants.Relations.Objects.NEWSLETTER, 1).then((result) => {
				if (result.hasRelation) {
					this.setState({isSubscribed: true});
				}
			}).catch(() => {
			});
		}
	}

	componentWillUnmount() {
		Flux.Guest.removeAddRelationResultListener(this.onResult);
	}

	onResult(success) {
		if (success) {
			this.setState({
				requestError: false,
				isSubscribed: true,
			});
		} else {
			this.setState({
				requestError: true,
				isSubscribed: false,
			});
		}
	}

	onClose() {
		if (this.props.containerId) {
			unmountComponentAtNode(document.getElementById(this.props.containerId));
		}

		if (this.props.onClose) {
			this.props.onClose();
		}
	}

	onSendClick() {
		if (!Flux.Guest.isLoggedIn()) {
			VXPay.openLogin();
			return;
		}

		this.setState({
			requestError: false,
			isSubscribed: false,
//			sending:      true,
		});

		Flux.Guest.addGuestRelation(Flux.Constants.Relations.Predicates.HAS_SUBSCRIBED, Flux.Constants.Relations.Objects.NEWSLETTER, 1);
	}

	render() {
		return (
			<div className="contests__modal__input-container-wrapper">
				<div>
					<VXButton line1={[new VXButtonLineConfig(Flux.Guest.isLoggedIn() ? Translations.get('DailyBonusControllerReceiveNewsletters') : Translations.get('DailyBonusEmailButtonLoggedOut'))]}
					          color={(this.state.isSubscribed ? COLOR_TYPE_DISABLED : COLOR_TYPE_MOOD_3)}
					          onClick={this.onSendClick}
					          disabled={!!this.state.isSubscribed}
					          staticMode={true}
					/>
				</div>
				{this.state.isSubscribed && <div className="contests__modal__confirmation-container">
					<div className="contests__modal__confirmation__headline">
						{Translations.get('ModalContestsConfirmationHeadline')}
					</div>
					<div className="contests__modal__confirmation">
						{Translations.get('ModalContestsConfirmation')}
					</div>
				</div>}
				{this.state.requestError && <div className="contests__modal__request-error">
					{Translations.get('ModalContestsRequestError')}
				</div>}
			</div>);
	}
}

SubscribeToContests.propTypes = {
	containerId: PropTypes.string,
	isMobile:    PropTypes.bool,
	onClose:     PropTypes.func,
};

SubscribeToContests.defaultProps = {
	isMobile: false,
};

export default SubscribeToContests;
